export const QUERY_CACHE = {
  USERS: 'users',
  ORG: 'ORG',
  MEASURE: 'measure',
  CRITERIA: 'criteria',
  PRINCIPLE: 'principle',
  INTRODUCTION: 'introduction'
}